import { TOGGLE_USER_SENTIMENT, CLOSE_USER_SENTIMENT } from '../actions';

type State = {
  isOpen: boolean;
};

type Actions = {
  type: 'TOGGLE_USER_SENTIMENT' | 'CLOSE_USER_SENTIMENT';
  state: boolean;
};

const initialState: State = {
  isOpen: false,
};

export default (state = initialState, action: Actions) => {
  if (!state) {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_USER_SENTIMENT:
      return {
        ...state,
        isOpen: !state.isOpen,
      };

    case CLOSE_USER_SENTIMENT:
      return {
        ...state,
        isOpen: false,
      };

    default:
      break;
  }

  return state;
};
